/*
 * @Description: 商城钱包相关路由配置
 * @Author: AI Assistant
 * @Date: 2024-01-01
 */

const shopPurse = [
    {
        path: '/purse',
        name: 'purse',
        component: () => import('@/views/shop_purse/index'),
        meta: {
            title: '我的钱包',
            keepAlive: true
        }
    },
    {
        path: '/alipay',
        name: 'alipay',
        component: () => import('@/views/shop_purse/alipay'),
        meta: {
            title: '支付宝支付',
            keepAlive: true
        }
    },
    {
        path: '/withdrawal',
        name: 'withdrawal',
        component: () => import('@/views/shop_purse/withdrawal'),
        meta: {
            title: '提现'
        }
    },
    {
        path: '/purselist',
        name: 'purselist',
        component: () => import('@/views/shop_purse/purselist'),
        meta: {
            title: '零钱明细'
        }
    },
    {
        path: '/purseDetail',
        name: 'purseDetail',
        component: () => import('@/views/shop_purse/purseDetail'),
        meta: {
            title: '交易详情'
        }
    },
    {
        path: '/refineInfo',
        name: 'refineInfo',
        component: () => import('@/views/shop_purse/refineInfo'),
        meta: {
            title: '完善信息'
        }
    },
    {
        path: '/evpi',
        name: 'evpi',
        component: () => import('@/views/shop_purse/evpi'),
        meta: {
            title: '添加银行卡'
        }
    },
    {
        path: '/bankList',
        name: 'bankList',
        component: () => import('@/views/shop_purse/bankList'),
        meta: {
            title: '银行卡管理'
        }
    },
    {
        path: '/addBank',
        name: 'addBank',
        component: () => import('@/views/shop_purse/addBank'),
        meta: {
            title: '添加银行卡'
        }
    },
    {
        path: '/purseBindBank',
        name: 'purseBindBank',
        component: () => import('@/views/shop_purse/bindBank'),
        meta: {
            title: '绑定银行卡'
        }
    },
    {
        path: '/purseChooseBank',
        name: 'purseChooseBank',
        component: () => import('@/views/shop_purse/chooseBank'),
        meta: {
            title: '选择银行'
        }
    },
    {
        path: '/RechargeYst',
        name: 'RechargeYst',
        component: () => import('@/views/shop_purse/RechargeYst'),
        meta: {
            title: '充值'
        }
    },
    {
        path: '/recharge',
        name: 'recharge',
        component: () => import('@/views/shop_purse/recharge'),
        meta: {
            title: '充值'
        }
    }
]

export default shopPurse